import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import FullPageLoader from "./loader/FullPageLoader";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { UpdateNewsapi } from "../utility/api";
import { useNavigate } from "react-router-dom";

const News = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  // const [editorContent, setEditorContent] = useRef([""]);

  const editorContent = useRef([""]);
  //console.log("editorContent", editorContent);
  const editorRef = useRef(null);

  const [userData, setUserData] = useState([]);
  const [isloading, setLoading] = useState(false);
  const userId = useSelector((state) => state.auth.userId);

  useEffect(() => {
    fetchNews();
  }, [page]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/admin/get-news?page=${page}&limit=${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setLoading(false);
      setUserData(data?.data);
      setTotalCount(data.page_data.total);
      setPageSize(data.page_data.limit);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };

  const handlePageChange = (data) => {
    setPage(data.selected + 1);
  };

  const handleStatusToggle = async (id, currentStatus) => {
    //console.log("id", currentStatus);
    const requestData = {
      created_by: userId,

      title: id?.job_title,
      news_category: id?.news_category,
      image_mime_type: id?.image_mime_type,
      image_alt: id?.image_alt,
      banner_image: id?.banner_image,
      slug_url: id?.slug_url,
      meta_title: id?.meta_title,
      meta_keywords: id?.meta_keywords,
      meta_description: id?.meta_description,
      short_description: id?.short_description,
      description: id?.description,
      status: currentStatus === "publish" ? "unpublish" : "publish",
    };

    try {
      const response = await UpdateNewsapi(id?._id, requestData);
      if (response?.data?.status === true) {
        fetchNews();
      } else {
        setLoading(false);
        console.error("Failed to create model");
      }
    } catch {}
  };

  const handlePageClick = (selectedPage) => {
    setPage(selectedPage.selected + 1);
  };

  return (
    <>
      {isloading ? (
        <FullPageLoader />
      ) : (
        <div className="container-fluid ps-3">
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                editorContent.current = [""];
                // setShow(true);
                navigate("/newsform");
              }}
            >
              Create News
            </button>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">Title</th>
                      <th scope="col">Short Description</th>
                      <th scope="col">Slug Url</th>
                      <th scope="col">Created At</th>
                      <th scope="col">Status</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData?.map((ele, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{ele?.title}</td>
                        <td>{ele?.short_description}</td>
                        <td>{ele?.slug_url}</td>

                        <td>{ele?.createdAt}</td>
                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={ele.status === "publish" ? 1 : 0}
                              onChange={() =>
                                handleStatusToggle(ele, ele.status)
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td>
                          <button
                            className="btn btn-info btn-sm"
                            onClick={() => navigate(`/newsform/${ele?._id}`)}
                            // handleShowDetails(ele._id)}
                          >
                            Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-4">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(totalCount / pageSize)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              forcePage={page - 1}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default News;
